import React from "react";
import "./Feedback.css";
import { Row, Col, Card, Button, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import { FaStar } from "react-icons/fa";

const Feedback = () => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [visibleCount, setVisibleCount] = useState(4);

  const reviews = [
    {
      name: "Amit",
      rating: 5,
      comment: "Amazing product!",
    },
    {
      name: "Honey",
      rating: 4,
      comment: "Very good, will recommend!",
    },

    {
      name: "Harvinder",
      rating: 5,
      comment: "Excellant",
    },

    {
      name: "Sumit",
      rating: 5,
      comment: "Amazing product!",
    },
    {
      name: "Smith",
      rating: 4,
      comment: "Very good, will recommend!",
    },

    {
      name: "Adarsh",
      rating: 1,
      comment: "Very poor service",
    },

    {
      name: "Amit",
      rating: 5,
      comment: "Amazing product!",
    },
    {
      name: "Honey",
      rating: 4,
      comment: "Very good, will recommend!",
    },

    {
      name: "Harvinder",
      rating: 5,
      comment: "Excellant",
    },

    {
      name: "Sumit",
      rating: 5,
      comment: "Amazing product!",
    },
    {
      name: "Smith",
      rating: 4,
      comment: "Very good, will recommend!",
    },

    {
      name: "Adarsh",
      rating: 1,
      comment: "Very poor service",
    },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const bottomReached =
        window.innerHeight + window.scrollY >= document.body.offsetHeight - 100;

      if (bottomReached && visibleCount < reviews.length) {
        setVisibleCount((prev) => prev + 2);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [visibleCount, reviews.length]);

  return (
    <>
      <div className="feedback">
        <div className="coustom_container">
          <h2>Customer's Review & Feedback Form</h2>

          <Row>
            {/* Left Column - Feedback Form */}
            <Col md={12}>
              <Card className="mb-4 p-4 rounded shadow bg-light">
                <Form>
                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-1 fs-5 fw-bolder py-3 text-dark py-sm-2 form-group">
                        <Form.Label>Name</Form.Label>
                        <Form.Control type="text" placeholder="Your name" />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="mb-1 fs-5 fw-bolder py-3 text-dark py-sm-2 form-group">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" placeholder="Your email" />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="mb-1 fs-5 fw-bolder py-3 text-dark py-sm-2 form-group">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Your phone number"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="mb-1 fs-5 fw-bolder py-3 text-dark py-sm-2 form-group">
                        <Form.Label>Ratings</Form.Label>
                        <div className="d-flex gap-2">
                          {[...Array(5)].map((star, index) => {
                            const currentRating = index + 1;
                            return (
                              <button
                                key={index}
                                type="button"
                                className="btn p-0 border-0 bg-transparent"
                                onClick={() => setRating(currentRating)}
                                onMouseEnter={() => setHover(currentRating)}
                                onMouseLeave={() => setHover(0)}
                              >
                                <FaStar
                                  size={28}
                                  color={
                                    currentRating <= (hover || rating)
                                      ? "#ffc107"
                                      : "#e4e5e9"
                                  }
                                  style={{ transition: "color 200ms" }}
                                />
                              </button>
                            );
                          })}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Group className="mb-3 fs-5 fw-bolder text-dark">
                    <Form.Label>Comment</Form.Label>
                    <Form.Control
                      as="textarea"
                      placeholder="message......"
                      rows={5}
                    />
                  </Form.Group>
                  <Button className="btn_submit">Submit</Button>
                </Form>
              </Card>
            </Col>

            {/* Right Column - Reviews */}
            {/* <Col md={6}>
              <div className="scrollable-reviews shadow-lg">
                <Row>
                  {reviews.map((review, index) => (
                    <Col md={12} key={index} className="mb-4">
                      <Card className="reveiw_cards h-100 shadow text-dark fw-bold">
                        <Card.Body>
                          <Card.Title>{review.name}</Card.Title>
                          <Card.Subtitle className="mb-2 text-muted">
                            {"⭐".repeat(review.rating)}
                          </Card.Subtitle>
                          <Card.Text>{review.comment}</Card.Text>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </div>
            </Col> */}
          </Row>
        </div>
      </div>
    </>
  );
};

export default Feedback;
